import isEmpty from "lodash/isEmpty";
import isNull from "lodash/isNull";
import { shallow } from "zustand/shallow";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import useStripePaymentMethodStore, {
  STRIPE_PAYMENT_METHODS_QUERY_KEYS,
} from "../store";
import { getActiveCustomer } from "../../../api/stripe";
import { bugNotif } from "../../../api/bugsnag";
import { getErrorMsg } from "../../../../Common/utils/common";
import { useWebUserStore } from "../../../CommonStores/user/users";
const useExistingStripeCustomerProvider = () => {
  const { setExistingCustomer } = useStripePaymentMethodStore(
    (state) => state,
    shallow
  );
  const [user] = useWebUserStore((state) => [state.user]);

  const { data: existingCustomerResult, error: existingCustomerError } =
    useQuery({
      queryKey: [STRIPE_PAYMENT_METHODS_QUERY_KEYS.existingCustomer, user],
      queryFn: async () => {
        if (
          user === undefined ||
          isNull(user) ||
          user.stripeId === undefined ||
          isEmpty(user.stripeId)
        ) {
          return undefined;
        }
        return await getActiveCustomer(user.stripeId);
      },
      refetchOnWindowFocus: true,
    });

  useEffect(() => {
    if (!isNull(existingCustomerError)) {
      bugNotif(
        STRIPE_PAYMENT_METHODS_QUERY_KEYS.existingCustomer,
        getErrorMsg(existingCustomerError).rawErrorMsg
      );
    }
  }, [existingCustomerError]);

  useEffect(() => {
    if (existingCustomerResult !== undefined) {
      setExistingCustomer(existingCustomerResult.data.result);
    }
  }, [existingCustomerResult]);
};

export default useExistingStripeCustomerProvider;
